import React, { useState, useEffect } from 'react';
import { getLayoutProps } from '@/utils/layout/layout';
import PageLayout from '@/components/PageLayout';
import Head from 'next/head';
import User from '@/store/user';
import { getUserV3 } from '@/api/users';
import Cookies from 'universal-cookie';
import isEmpty from 'lodash/isEmpty';
/* Controllers */

import styles from '@/styles/Corporate.module.css';
import CheckoutPage from '@/components/Checkout/Checkout';

export default function Checkout({ responsiveLogo, emptyStates }) {
  const [user, setUser] = useState();
  const cookies = new Cookies();
  const token = cookies.get('token');

  // useEffect(() => {
  //   const user$ = User.subscribe(_user => {
  //     setUser(_user);
  //   });

  //   return () => user$.unsubscribe();
  // }, []);

  useEffect(() => {
    async function getCurrentUser(token) {
      const updatedUser = await getUserV3(token);

      // Error case
      if (isEmpty(updatedUser)) return;

      setUser({
        ...updatedUser,
        authToken: token,
      });
      User.update({
        ...updatedUser,
        authToken: token,
      });
    }
    if (token) {
      getCurrentUser(token);
    }
  }, []);

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>

      <main className={styles.mainContainer}>
        <div className={styles.categoriesContainer}>
          <CheckoutPage user={user} defaultWarningImage={emptyStates?.default_warning?.url} />
        </div>
      </main>
    </>
  );
}

Checkout.getLayout = function getLayout(page) {
  return <PageLayout>{page}</PageLayout>;
};

export async function getStaticProps(context) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, context.locale);

  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${context.locale}/common.json`)).default,
    checkout: (await import(`../../../prebuild-data/i18n/${context.locale}/checkout.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
    },
  };
}
